import type { ConfirmedAppointmentData } from '@/features/appointments/utils/ConfirmedAgentInfo';

export type LandingPageRedirectState = {
  selectedDestination?: {
    workTypeId?: string;
  };
  appointmentId?: string;
  confirmedAppointment?: ConfirmedAppointmentData;
  sessionSource?: string;
};

export const shouldSkipLandingPageRedirect = ({
  selectedDestination,
  appointmentId,
  confirmedAppointment,
  sessionSource,
}: LandingPageRedirectState): boolean => {
  const hasDestination = Boolean(selectedDestination?.workTypeId?.length);
  const hasLoadedAppointment =
    Boolean(appointmentId) && Boolean(confirmedAppointment);
  const isEmailLoadedAppointment =
    sessionSource === 'email' && Boolean(appointmentId);

  return hasLoadedAppointment || hasDestination || isEmailLoadedAppointment;
};

export const resolveLandingPagePath = (isEmailFlow: boolean): '/' | '/email' =>
  isEmailFlow ? '/email' : '/';
